import { render } from "./EvenementComponent.vue?vue&type=template&id=3f1209e9"
import script from "./EvenementComponent.vue?vue&type=script&lang=js"
export * from "./EvenementComponent.vue?vue&type=script&lang=js"

import "./EvenementComponent.vue?vue&type=style&index=0&id=3f1209e9&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__